/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { ErrorHandler } from '../core/error.service';
import { Observable } from 'rxjs';
import { JSONSearchParams } from '../core/search.params';
import { Http } from '@angular/http';
import { SocketConnection } from '../../sockets/socket.connections';import { SunfishAuthenticatorService } from '../../models/SunfishAuthenticatorService';

/**
 * Api services for the `SunfishAuthenticatorService` model.
 */
@Injectable()
export class SunfishAuthenticatorServiceApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http, connection, models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `companyCode` – `{string}` -
   *
   *  - `username` – `{string}` -
   *
   *  - `authCode` – `{string}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SunfishAuthenticatorService` object.)
   * </em>
   */
  public notify(companyCode: any, username: any, authCode: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SunfishAuthenticatorServices/notify";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof companyCode !== 'undefined' && companyCode !== null) _urlParams.companyCode = companyCode;
    if (typeof username !== 'undefined' && username !== null) _urlParams.username = username;
    if (typeof authCode !== 'undefined' && authCode !== null) _urlParams.authCode = authCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} deviceSignature
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SunfishAuthenticatorService` object.)
   * </em>
   */
  public check2FA(deviceSignature: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SunfishAuthenticatorServices/check2FA";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof deviceSignature !== 'undefined' && deviceSignature !== null) _urlParams.deviceSignature = deviceSignature;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `authCode` – `{string}` -
   *
   *  - `confirm` – `{boolean}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SunfishAuthenticatorService` object.)
   * </em>
   */
  public update2FA(authCode: any, confirm: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SunfishAuthenticatorServices/update2FA";
    let _routeParams: any = {};
    let _postBody: any = {
      data: {
        authCode: authCode,
        confirm: confirm
      }
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} deviceSignature
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SunfishAuthenticatorService` object.)
   * </em>
   */
  public isAuthorized(deviceSignature: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SunfishAuthenticatorServices/isAuthorized";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof deviceSignature !== 'undefined' && deviceSignature !== null) _urlParams.deviceSignature = deviceSignature;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `deviceSignature` – `{string}` -
   *
   *  - `deviceInfo` – `{string}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SunfishAuthenticatorService` object.)
   * </em>
   */
  public authorizeThisDevice(deviceSignature: any, deviceInfo: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SunfishAuthenticatorServices/authorizeThisDevice";
    let _routeParams: any = {};
    let _postBody: any = {
      data: {
        deviceSignature: deviceSignature,
        deviceInfo: deviceInfo
      }
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SunfishAuthenticatorService`.
   */
  public getModelName() {
    return "SunfishAuthenticatorService";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SunfishAuthenticatorService.ts